<template>
  <div>
    <div class="page-header">
      <div class="container-fluid d-flex align-items-center justify-content-between">
       <h2 class="h4 no-margin-bottom">Cihaz</h2>
       <div class="right-menu list-inline no-margin-bottom">
          <router-link to="/create/cihaz"><button type="submit" class="btn submit bg-dark text-light">Yeni Cihaz</button>
          </router-link>
          <router-link to="/liste/cihaz"><button type="submit" class="btn submit bg-dark text-light">Liste</button>
          </router-link>          
       </div>
      </div>
    </div>
    <section class="no-padding-top no-padding-bottom">
      <div class="container-fluid">
        <div class="row">
          <div class="col-lg-6 col-12">
                <div class="pie-chart chart block">
                  <div class="title"><strong>Cihaz Alias</strong></div>
                  <div class="pie-chart chart margin-bottom-sm">
                    <apexchart type="pie" width="100%" :options="alias.chartOptions" :series="alias.series"></apexchart>
                  </div>
                </div>
          </div>
          <div class="col-lg-6 col-12">
                <div class="pie-chart chart block">
                  <div class="title"><strong>Cihaz Durum</strong></div>
                  <div class="pie-chart chart margin-bottom-sm">
                    <apexchart type="pie" width="100%" :options="durum.chartOptions" :series="durum.series"></apexchart>
                  </div>
                </div>
          </div>          
          <div class="col-lg-6 col-12">
                <div class="pie-chart chart block">
                  <div class="title"><strong>Cihaz Model</strong></div>
                  <div class="pie-chart chart margin-bottom-sm">
                    <apexchart type="pie" width="100%" :options="model.chartOptions" :series="model.series"></apexchart>
                  </div>
                </div>
          </div>

          
        </div>
      </div>
    </section>
    <div v-if="progres.inprogres">
      <div id="spinner-front" class="show"> <img src="/set/ajax-loader.gif"/><br>{{progres.mesaj}} ...</div>
      <div id="spinner-back" class="show"></div>
    </div>      
  </div>
</template>

<script>
export default {
   created() {
     this.progres.inprogres = true
     this.yetki()
  },
  data () {
    return {
              progres : {
          mesaj:'Bekleyiniz',
          inprogres:false
        }  ,      
          table : this.$route.params.cihaz,
          posts : [],
          error :[],
          durum : {},
          alias : {},
          model : {},
          firma:this.$request.ayar().firmaid,
          ya:this.$request.ayar().ya,
          kid:this.$request.ayar().kid
    }
  },
    methods : {
        yetki: function(){
          if (this.$helper.sayfayetki(493225)){
            let islem =false;
            switch(this.ya) {
              case 'said':
                this.ya = 'said';
                islem = true
                break;
              case 'carid':
                this.ya='carid';
                islem = true;
                break;
              default:
                islem = true;
                this.ya = 'fid';
            }

            if (islem) {this.getPostsAsync()}
          }
          else{
            alert('Bu alanı kullanım yetkiniz yok')
            this.$router.go(-1)
          }
        },

        getPostsAsync (){
          this.$request.get("liste/"+this.ya+"/"+this.kid+"/"+this.firma)
          .then(res => {
            this.alias = this.$helper.piechart(this.$helper.groupByAdet(res.results,'alias')),
            this.model = this.$helper.piechart(this.$helper.groupByAdet(res.results,'model')),
            this.durum = this.$helper.piechart(this.$helper.groupByAdet(res.results,'cdalias'))
            this.progres.inprogres = false
            })
          .catch(err => {this.error.push(err)})
        }
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/cihaz/cihazgrafik.vue